"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageGDR = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var quotetable_1 = require("../quotetable");
/**
 * 瑞士GDR
 */
function PageGDR() {
    return (react_1.default.createElement("div", { className: "pageGDR" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, { insertRight: react_1.default.createElement("span", { className: "delaytips" }, "\u6E29\u99A8\u63D0\u793A\uFF1A\u5F53\u524D\u5217\u8868\u6570\u636E\u5EF6\u8FDF15\u5206\u949F") }),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageGDR = PageGDR;
